import EnemyType from "../../enums/EnemyType";
import EnemyData from "./EnemyDataInterface";

const SWARM_ENEMYS: {
  [key in EnemyType]?: EnemyData[];
} = {
  [EnemyType.HAMSTER_SWARM]: [
    {
      level: 1,
      maxHp: 0.1,
      speed: 600,
      power: 2,
      knockback: 0,
      deathKB: 0,
      killedAmount: 0,
      xp: 1.5,
      scale: 0.8,
      spriteName: "fat_hamster",
      animationKey: "fat_hamster_run",
      skills: ["FixedDirection"],
    },
  ],
  [EnemyType.SCORPION_SWARM]: [
    {
      level: 1,
      maxHp: 1,
      speed: 800,
      power: 4,
      knockback: 0,
      deathKB: 0,
      killedAmount: 0,
      xp: 1.5,
      scale: 0.8,
      spriteName: "scorpion",
      animationKey: "scorpion_run",
      skills: ["FixedDirection"],
    },
  ],
  [EnemyType.VULTURE_SWARM]: [
    {
      level: 1,
      maxHp: 4,
      speed: 800,
      power: 6,
      knockback: 0,
      deathKB: 0,
      killedAmount: 0,
      xp: 1.5,
      scale: 0.8,
      spriteName: "vulture",
      animationKey: "vulture_run",
      skills: ["FixedDirection"],
    },
  ],
};
export default SWARM_ENEMYS;
